import { Link } from 'react-router-dom';

const privacyUrl = 'https://ecokhalilov.getcourse.ru/politic';
const offerUrl = 'https://ecokhalilov.getcourse.ru/ofertaprod';

export default function Footer() {
  return (
    <footer className="bg-sand">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-2 mb-4">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center">
                <img
                  src="/assets/readdy/khalilov-logo.png"
                  alt="Крестьянское хозяйство Ивана Халилова"
                  className="h-full w-full object-contain"
                />
              </div>
              <span className="font-display flex flex-col text-[12px] font-semibold leading-[1.05] text-dark">
                <span>Крестьянское хозяйство</span>
                <span className="whitespace-nowrap">Ивана Халилова</span>
              </span>
            </Link>
            <p className="text-sm text-dark/60 leading-relaxed max-w-xs">
              Натуральные продукты пчеловодства и средства для заботы о здоровье. Прямо с пасеки — в ваш дом.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-display text-sm font-semibold text-dark mb-4">Навигация</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/catalog" className="text-sm text-dark/60 hover:text-honey-dark transition-colors">Каталог</Link>
              <Link to="/services" className="text-sm text-dark/60 hover:text-honey-dark transition-colors">Пасека под ключ</Link>
              <Link to="/delivery" className="text-sm text-dark/60 hover:text-honey-dark transition-colors">Доставка</Link>
              <Link to="/about" className="text-sm text-dark/60 hover:text-honey-dark transition-colors">О нас</Link>
              <Link to="/contacts" className="text-sm text-dark/60 hover:text-honey-dark transition-colors">Контакты</Link>
            </nav>
          </div>

          {/* Contacts */}
          <div>
            <h4 className="font-display text-sm font-semibold text-dark mb-4">Контакты</h4>
            <div className="flex flex-col gap-2">
              <a
                href="https://t.me/ivankhalilov"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-dark/60 hover:text-nature transition-colors flex items-center gap-2"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-telegram-line text-xs" />
                </div>
                Telegram канал
              </a>
              <a
                href="https://www.youtube.com/@ivankhalilov"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-dark/60 hover:text-red-500 transition-colors flex items-center gap-2"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-youtube-line text-xs" />
                </div>
                YouTube
              </a>
              <a
                href="tel:88005513528"
                className="text-sm text-dark/60 hover:text-honey-dark transition-colors flex items-center gap-2"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-xs" />
                </div>
                8 800 551 35 28
              </a>
              <a
                href="mailto:info@ecokhalilov.ru"
                className="text-sm text-dark/60 hover:text-honey-dark transition-colors flex items-center gap-2"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-xs" />
                </div>
                info@ecokhalilov.ru
              </a>
              <a
                href="https://t.me/ecoacademybot"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-dark/60 hover:text-nature transition-colors flex items-center gap-2"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-xs" />
                </div>
                Поддержка
              </a>
              <a
                href="https://vk.com/nil18"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-dark/60 hover:text-honey-dark transition-colors flex items-center gap-2"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-vk-line text-xs" />
                </div>
                VK
              </a>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-display text-sm font-semibold text-dark mb-4">Юридическая информация</h4>
            <div className="flex flex-col gap-2">
              <a href={privacyUrl} target="_blank" rel="noopener noreferrer" className="text-sm text-dark/60 hover:text-honey-dark transition-colors">Политика конфиденциальности</a>
              <a href={offerUrl} target="_blank" rel="noopener noreferrer" className="text-sm text-dark/60 hover:text-honey-dark transition-colors">Договор оферты</a>
            </div>
            <div className="mt-4 text-xs text-dark/40 leading-relaxed">
              ИП Соловьев Марк Олегович<br />
              ОГРНИП 325180000107366<br />
              ИНН 181603654344
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-dark/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-dark/40">© 2026 Крестьянское хозяйство Ивана Халилова. Все права защищены.</p>
          <p className="text-xs text-dark/40">Сделано с заботой о природе</p>
        </div>
      </div>
    </footer>
  );
}
